import { render, staticRenderFns } from "./OrderFinish.vue?vue&type=template&id=31b8f7da&scoped=true"
import script from "./OrderFinish.vue?vue&type=script&lang=js"
export * from "./OrderFinish.vue?vue&type=script&lang=js"
import style0 from "./OrderFinish.vue?vue&type=style&index=0&id=31b8f7da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b8f7da",
  null
  
)

export default component.exports